__turbopack_context__.v({
  "expand_btn": "IR_PPa_expand_btn",
  "list_block": "IR_PPa_list_block",
  "richtext": "IR_PPa_richtext",
});
